import { Subject } from 'rxjs';

const subject = new Subject();

export const eventService = {
    fire: (data) => subject.next(data),
    get: () => subject.asObservable()
};